import styled from "styled-components";

export const StylesTable = styled.div`
  @media screen {
    position: absolute;
    top: 0;
    left: -99999px;
  }

  .data-table {
    width: 100%;
    border-collapse: collapse;
  }
  .data-table th {
    white-space: pre;
  }

  .data-table th,
  .data-table td {
    padding: 0px 2px;
    border: 1px solid #d9d9d9;
    text-align: center;
    font-size: 12px;
    white-space: pre;
  }

  .data-table th {
    background-color: #f5f5f5;
    font-weight: 600;
  }
`;
